import { DateFormat, formatDate } from "common";
import { Dayjs } from "dayjs";
import { Source, Transaction, TransactionType } from "types";

export const purchaseTypes: TransactionType[] = [
    TransactionType.PURCHASE,
    TransactionType.REFUND,
    TransactionType.REFUND_COMMISSION,
    TransactionType.DEPOSIT,
    TransactionType.BALANCE,
    TransactionType.PURCHASE_AFFILIATE,
    TransactionType.REDEEM,
    TransactionType.PLUGIN_FEE,
];

export const transactionSources: Source[] = [
    Source.CHECKOUT,
    Source.GIFT,
    Source.KIOSK,
    Source.IMPORT,
    Source.OFFICE,
    Source.REFUND,
    Source.XOLA,
];

export const getProcessingFee = (transaction: Transaction) => {
    let fee = 0;

    for (const item of transaction.items) {
        const commissionSplit = item.commissionSplitAmount;
        fee += commissionSplit ? commissionSplit.creditCard : item.commission;
    }

    return fee;
};

export const getGuestFee = (transaction: Transaction) => {
    let fee = 0;

    for (const item of transaction.items) {
        const commissionSplit = item.commissionSplitAmount;
        fee += commissionSplit ? commissionSplit.offline : 0;
    }

    return fee;
};

export const getMerchandiseFee = (transaction: Transaction) => {
    let fee = 0;

    for (const item of transaction.items) {
        const commissionSplit = item.commissionSplitAmount;
        fee += commissionSplit?.ware ?? 0;
    }

    return fee;
};

export const getPartnerFee = (transaction: Transaction) => {
    let fee = 0;

    for (const item of transaction.items) {
        const commissionSplit = item.commissionSplitAmount;
        const sellerAmount = commissionSplit ? commissionSplit.seller : 0;
        const travelerAmount = commissionSplit ? commissionSplit.traveler : 0;
        const total = sellerAmount + travelerAmount;
        fee += total;
    }

    return fee;
};

export const getTransactionDateParams = (from: Dayjs, to: Dayjs) => {
    return { createdAt: [formatDate(from, DateFormat.DATE_TIME_ISO), formatDate(to, DateFormat.DATE_TIME_ISO)] };
};

export const isPartnerReconcileTransaction = (transaction: Transaction) => {
    return (
        transaction.type === TransactionType.PARTNER_RECONCILE_AUTO ||
        transaction.type === TransactionType.PARTNER_RECONCILE_MANUAL
    );
};
